import {Collapse, Divider, Drawer, List, useTheme, Box, Typography} from "@mui/material";
import useDrawerItems from "./useDrawerItems";
import React, {useState} from "react";
import {useNavigate} from "react-router";
import {DrawerHeaderStyled, DrawerStyled} from "./SidebarStyles";
import Copyright from "../../shared/copyright/Copyright";
import CustomListItem from "./custom-list-tem/CustomListItem";
import drawerWidth from "../NavigationHelper";
import PropTypes from "prop-types";
import {useLogo} from "../../../contexts/logo-context/LogoContext";
import VersionDisplay from "../../shared/version/VersionDisplay";

const Sidebar = ({sidebarOpen, setSidebarOpen, setIsClosing}) => {
    const theme = useTheme();
    const [drawerItems] = useDrawerItems();
    const navigate = useNavigate();
    const [openCollapse, setOpenCollapse] = useState({});
    const { logoUrl } = useLogo();

    const handleDrawerClose = () => {
        setIsClosing(true);
        setSidebarOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleItemClick = (route) => {
        navigate(route);
    };

    const handleOpenCollapse = (route) => {
        setOpenCollapse({[route]: !openCollapse[route]})
    }

    const drawerBody = (
        <>
            {logoUrl ? (
                <img src={logoUrl} alt="" width="100%"/>
            ) : (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    padding: 2,
                    minHeight: '80px'
                }}>
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center'
                        }}
                    >
                        LOGO
                    </Typography>
                </Box>
            )}
            <DrawerHeaderStyled/>
            <List>
                {drawerItems.map((item, idx) => (
                    item.icon ? (
                        item.subItems ?
                            <React.Fragment key={`drawer-item-${idx}`}>
                                <CustomListItem
                                    item={item}
                                    open={true}
                                    handleItemClick={() => handleOpenCollapse(idx)}
                                    openCollapse={openCollapse[idx]}
                                />
                                <Collapse in={openCollapse[idx]} timeout="auto" unmountOnExit>
                                    {
                                        item.subItems.map((subItem, id) => {
                                            return (
                                                <React.Fragment key={`drawer-subItem-${id}`}>
                                                    <CustomListItem
                                                        item={subItem}
                                                        open={true}
                                                        handleItemClick={handleItemClick}/>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </Collapse>
                            </React.Fragment> :
                            <React.Fragment key={`drawer-item-${idx}`}>
                                <CustomListItem
                                    item={item}
                                    open={true}
                                    handleItemClick={handleItemClick}/>
                            </React.Fragment>
                    ) : <Divider key={item.text} color="#27344E" sx={{mb: 2}}/>
                ))}
            </List>
                <List sx={{bottom: 0, position: "absolute"}}>
                    <Copyright/>
                </List>
        </>
    )

    return (<>
            <Drawer
                variant="temporary"
                open={sidebarOpen}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: {xs: 'block', sm: 'none'},
                    '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: theme.palette.darkBackground.main,
                        color: theme.palette.common.white,
                        p: 2,
                        minWidth: 78,
                    },
                }}
            >
                {drawerBody}
            </Drawer>
            <DrawerStyled
                variant="permanent"
                sx={{
                    display: {xs: 'none', sm: 'block'},
                    '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: theme.palette.darkBackground.main,
                        color: theme.palette.common.white,
                        p: 2,
                        minWidth: 78,
                    },
                }}
                open
            >
                {drawerBody}
            </DrawerStyled>
            <VersionDisplay />
        </>
    );
};

Sidebar.propTypes = {
    sidebarOpen: PropTypes.bool.isRequired,
    setSidebarOpen: PropTypes.func.isRequired,
    setIsClosing: PropTypes.func.isRequired
}

export default Sidebar;